import { ICorporatePartner } from './corporate-partner.interface';

export class StandaloneSmePartner implements ICorporatePartner {
  public name = 'standalone-sky';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'rewards';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class StandaloneSkySmePartner implements ICorporatePartner {
  public name = 'standalone-sky-skyb';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = false;
  public displayInlineText = 'rewards';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}

export class StandaloneOaSmePartner implements ICorporatePartner {
  public name = 'standalone-oa-sme';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'rewards';
  public showPopupForEcert = true;
  public showBusinessText = true;
  public showBusinessMilesLabel = true;
}
